import type {ObjectDirective} from "vue";
import type {FactoryArg} from "imask";
import {IMaskDirective} from "vue-imask";

const {beforeMount, updated, unmounted} = IMaskDirective;
if (
  typeof beforeMount !== "function" ||
  typeof updated !== "function" ||
  typeof unmounted !== "function"
) {
  throw new Error("vue-imask не предоставляет хуки директивы для Vue 3");
}

export const imaskDirective: ObjectDirective<HTMLInputElement, FactoryArg> = {
  beforeMount,
  updated,
  unmounted
};
